<template>
  <div class="tw-mx-auto tw-text-primary tw-font-normal">
    <!-- Header -->
    <div>
      <h2 class="tw-text-lg tw-leading-7 tw-font-normal tw-text-primary tw-mb-0">
        Send Notification
      </h2>
    </div>

    <!-- Form -->
    <base-form ref="form" v-model="isFormValid" class="tw-mt-4">
      <base-textarea label="Notification Message" placeholder="Enter notification message" v-model="notification.message" required :rows="3" class="" />
      <div class="tw-mt-4 tw-text-right">
        <base-button :disabled="!isFormValid || isSubmitting" :loading="isSubmitting" @click="submitNotification" variant="primary">
          <span v-if="!isSubmitting">Send Notification</span>
          <span v-else>Sending...</span>
        </base-button>
      </div>
    </base-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SalesNotificationManager",
  props: {
    businessId: String,
  },
  data() {
    return {
      isFormValid: false,
      isSubmitting: false,
      isLoading: false,
      notification: {
        message: "",
      },
    };
  },
  computed: {
    ...mapGetters("role", ["isPredictile", "isBusinessManagement", "isBusinessAdministrator", "isLocationFiltered"]),
  },
  created() {
    // this.loadPage();
  },
  methods: {
    async submitNotification() {
      if (!this.$refs.form.validate()) return;

      try {
        this.isSubmitting = true;
        await this.$axios.post(`/businesses/${this.businessId}/notification`, {
          message: this.notification.message,
        });
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Notification Send", message: "The notofication has been send successfully." });
        this.EventBus.$emit("NOTIFICATION_SENT");
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Failed to send notification",
          message: `We were not able to create the notification. Please try again.`,
          error,
        });
        throw error;
      } finally {
        this.isSubmitting = false;
        this.notification.message = "";
      }
    },
  },
};
</script>
